module.exports = __webpack_public_path__ + "static/srce-5a3452d7b85699b767456ee04abf84c6.svg";